import React, { useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import useDetectScrollPosition from '../../hooks/useDetectScrollPosition';
import {
  Loading,
} from "@minchat/react-chat-ui";
import { useChat } from "../../contexts/ChatProvider";
import CarouselMessage from "./CarouselMessage";
import Message from "./Message";
import TypingIndicator from "../typing-indicator";
import MessageInput from '../message-input';

const Container = styled.div`
    height: 100%;
    position: relative;
    top: ${({isOffset}) => isOffset ? "120px" : 0 };
    max-height: 90vh;
    overflow-y: hidden;
    padding-left: 0px;
    padding-bottom: 2px !important;
`;

const InnerContainer = styled.div`
    // height: 100%;
    padding-bottom: 2px !important;
`;

const ScrollContainerFullScreen = styled.div`
    overflow-y: auto;
    position: relative;
    // height: 100%;
    // width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    scrollbar-width: none;
    ::-webkit-scrollbar {
        background-color: white;
        height: 4px;
      }
      ::-webkit-scrollbar-track {
        background: white;
      }
      ::-webkit-scrollbar-thumb {
        background-color: white;
        border-radius: 1px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: white;
      }
`;
const Buffer = styled.div`
    height: 6px;
    width: 100%;
    position: relative;
`;


const RetryLink = styled.div`
    color: #007bff; /* Set the text color */
    text-decoration: underline; /* Add underline decoration */
    cursor: pointer; /* Show pointer cursor on hover */
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 14px;
`;

const RetryMessageContainer = styled.div`
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 14px;
    margin: 2px;
`;

const RetryContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    position: absolute;
`;

const LoadingContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    position: absolute;
`;
const EmptySpace = styled.div`
    height: 80px;
    min-height: 80px;
    flex: 0 0 80px;
    width: 100%;
    pointer-events: none;
`;

const ChatContainerFullScreen = ({
    // loading = false,
    typingIndicatorContent,
    customTypingIndicatorComponent,
    deviceWidth,
    onSendMessage
}) => {
    const {
        showTypingIndicator,
        theme,
        messages,
        fetchConversations,
        loading,
        setLoading,
        loadConversation,
        error,
        setError,
    } = useChat();
    const containerRef = useRef(null);
    const bottomBufferRef = useRef(null);
    const scrollContainerRef = useRef(null);
    const { detectBottom } = useDetectScrollPosition(scrollContainerRef);
    const [ scrollDownIndicator, setScrollDownIndicator ] = useState(false);

    useEffect(() => {
        setTimeout(() => { scrollToBottom();}, 0);
    }, [scrollDownIndicator]);

    useEffect(() => {
        if (loadConversation) {
            setLoading(true);
            fetchConversations()
                .then(() => setLoading(false))
                .catch(() => setLoading(false));
        }
    }, [loadConversation]);

    const handleScroll = () => {
        const container = scrollContainerRef.current;
        if (container && container.scrollTop === 0) {
            const currentScrollPosition = container.scrollHeight - container.scrollTop;
            fetchConversations()
                .then(() => {
                    //container.scrollTop = container.scrollHeight - currentScrollPosition;
                    container.scrollTo({
                        top: container.scrollHeight - currentScrollPosition,
                        behavior: "smooth",
                    });
                })
                .catch(() => { });
        }
    };

    useEffect(() => {
        const container = scrollContainerRef.current;
        container?.addEventListener('scroll', handleScroll);
        return () => {
            container?.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToBottom = () => {
        if (bottomBufferRef.current && scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const scrollPoint = bottomBufferRef.current;
            const parentRect = container.getBoundingClientRect();
            const childRect = scrollPoint.getBoundingClientRect();
            const scrollOffset = childRect.top + container.scrollTop - parentRect.top;

            if (container.scrollBy) {
                container.scrollBy({ top: scrollOffset, behavior: "smooth" });
            } else {
                container.scrollTop = scrollOffset;
            }
        }
    };

    return (
        <Container ref={containerRef} isOffset={!(loading || error)}>
            {/* <MessageListBackground roundedCorners={false} /> */}
            <InnerContainer>
                {loading ? (
                    <LoadingContainer>
                        {<Loading themeColor={theme} />}
                    </LoadingContainer>
                ) : error ?
                    <RetryContainer>
                        <RetryMessageContainer>
                            Failed to load the conversation
                        </RetryMessageContainer>
                        <RetryLink onClick={() => {
                            setLoading(true);
                            setError('');
                            fetchConversations()
                                .then(() => setLoading(false))
                                .catch(() => setLoading(false));
                        }}>
                            Try again
                        </RetryLink>
                    </RetryContainer>
                    : (
                        <ScrollContainerFullScreen
                            onScroll={handleScroll}
                            ref={scrollContainerRef}
                        >
                            <div
                                style={{
                                    backgroundColor: "white",
                                    display: "flex",
                                    flexDirection: 'column',
                                    alignSelf: 'center',
                                    alignItems: 'start',
                                    maxWidth: deviceWidth <= 1024 ? (deviceWidth-200)+"px" : "940px",
                                    width: deviceWidth <= 1024 ? (deviceWidth-200)+"px" : "clamp(810px, 60vw, 940px)",
                                    maxHeight: "88vh",
                                    margin:"auto"
                                }}
                            >
                                {messages && messages.map((message, index) => {
                                    // Determine the type of message to render
                                    let lastClusterMessage, firstClusterMessage, last, single;


                                    //if it is the first message in the messages array then show the header
                                    if (index === 0) {
                                        firstClusterMessage = true
                                    }
                                    //if the previous message from a different  then show the header
                                    if (index > 0 && messages[index - 1].user !== message.user) {
                                        firstClusterMessage = true
                                    }
                                    //if it is the last message in the messages array then show the avatar and is the last incoming
                                    if (index === messages.length - 1) {
                                        lastClusterMessage = true;
                                        last = true
                                    }
                                    //if the next message from a different user then show the avatar and is last message incoming
                                    if (index < messages.length - 1 && messages[index + 1].user !== message.user) {
                                        lastClusterMessage = true;
                                        last = true
                                    }
                                    //if the next message and the previous message are not from the same message.user then single incoming is true
                                    if (index < messages.length - 1 && index > 0 && messages[index + 1].user !== message.user && messages[index - 1].user !== message.user) {
                                        single = true
                                    }
                                    //if it is the first message in the messages array and the next message is from a different user then single incoming is true
                                    if (index === 0 && index < messages.length - 1 && messages[index + 1].user !== message.user) {
                                        single = true
                                    }
                                    //if it is the last message in the messages array and the previous message is from a different user then single incoming is true
                                    if (index === messages.length - 1 && index > 0 && messages[index - 1].user !== message.user) {
                                        single = true
                                    }
                                    //if the messages array contains only 1 message then single incoming is true
                                    if (messages.length === 1) {
                                        single = true
                                    }

                                    if (message.type === 'outgoing') {
                                        return (
                                            <div key={message._id} style={{ marginTop: '16px', width: "100%"}}>
                                                <Message
                                                    type={message.type}
                                                    text={message.text}
                                                    seen={message.seen}
                                                    created_at={message.createdAt}
                                                    showAvatar={true}
                                                    last={single ? false : last}
                                                    single={single}
                                                    scrollToBottom={scrollToBottom}
                                                    isFullScreen={true}
                                                />
                                            </div>
                                        )
                                    } else if (message.type === 'carousel') {
                                        return (
                                            <CarouselMessage
                                                type='incoming'
                                                key={message._id}
                                                _id={message._id}
                                                user={message.user}
                                                recommendations={message.recommendations}
                                                media={{ urls: ['https://picsum.photos/id/1/100', 'https://picsum.photos/id/2/100', 'https://picsum.photos/id/3/100'] }}
                                                seen={message.seen}
                                                created_at={message.createdAt}
                                                showAvatar={true}
                                                text={''}
                                                windowWidth={containerRef?.current?.clientWidth}
                                                isFullScreen={true}
                                            />
                                        )
                                    } else {
                                        return (
                                            <div key={message._id} style={{ marginTop: '16px', width: "100%"}}>
                                                <Message
                                                    isFullScreen={true}
                                                    type={message.type}
                                                    text={message.text}
                                                    question_data={message.question_data}
                                                    question_data_answer={message.question_data_answer}
                                                    handleCheckboxVisibility={(value) => setScrollDownIndicator(value)}
                                                    onSendMessage={onSendMessage}
                                                    seen={message.seen}
                                                    created_at={message.createdAt}
                                                    showAvatar={true}
                                                    avatar={message.avatar}
                                                    showHeader={firstClusterMessage}
                                                    clusterFirstMessage={firstClusterMessage}
                                                    clusterLastMessage={lastClusterMessage}
                                                    isLastMessage={index === messages.length - 1}
                                                    last={single ? false : last}
                                                    single={single}
                                                    style={{
                                                        marginRight: '10px',
                                                        marginTop: '16px !important',
                                                        marginBottom: '16px !important'
                                                    }}
                                                />
                                            </div>
                                        );
                                    }
                                })}

                                {showTypingIndicator && (
                                    <div style={{ display: 'flex', justifyContent: 'start' }}>
                                        {customTypingIndicatorComponent ?
                                            customTypingIndicatorComponent
                                            :
                                            <TypingIndicator
                                                content={typingIndicatorContent}
                                                themeColor={theme} />}
                                    </div>
                                )}
                                <EmptySpace />
                                {/* Bottom buffer */}
                                <Buffer ref={bottomBufferRef} />
                                
                            </div>
                            
                        </ScrollContainerFullScreen>
                    )}
            </InnerContainer>
        </Container>
    );
};

export default ChatContainerFullScreen;
